import { cn } from '@/lib/utils'
import { format } from 'date-fns'
import { memo } from 'react'

const Time = ({ date, className }: { className?: string; date?: string }) => {
  if (!date) {
    return null
  }

  const formattedDate = format(date, 'dd.MM.yyyy')
  const dateTime = format(date, 'yyyy-MM-yyyy')

  return (
    <time
      dateTime={dateTime}
      className={cn('textstyle-md-regular block', className)}
    >
      {formattedDate}
    </time>
  )
}

Time.displayName = 'Time'

export default memo(Time)
